// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/semantic/theme/modules/checkbox-theme.css
// module id = 1900
// module chunks = 0